import { SegmentStrategy } from "../rules/intoSegments";
import { RuleSet } from "../rules/ruleSet";

/** Spanish spelling */
export const ipaToSpanish: RuleSet = {
  inputSegments: SegmentStrategy.Ipa,
  outputSegments: SegmentStrategy.Single,
  rules: [
    // remove stress
    { from: 'ˈ', to: '' },
    { from: 'ˌ', to: '' },

    // consonants
    { from: 'b', to: 'b' }, // or v
    { from: 'β', to: 'v' }, // or b
    { from: 'tʃ', to: 'ch' },
    { from: 'd', to: 'd' },
    { from: 'ð', to: 'd' },
    { from: 'f', to: 'f' },
    { from: 'g', to: 'g' },
    { from: 'k', to: 'qu', next: { or: ['/e/', '/i/'] } }, { from: 'k', to: 'c' },
    { from: 'ɣ', to: 'g' },
    { from: 'l', to: 'l' },
    { from: 'ʎ', to: 'll' },
    { from: 'm', to: 'm' },
    { from: 'n', to: 'n' },
    { from: 'ɲ', to: 'ñ' },
    { from: 'ŋ', to: 'n' },
    { from: 'p', to: 'p' },
    { from: 'ɾ', to: 'r' },
    { from: 'r', to: 'r', previous: ['#word'] }, { from: 'r', to: 'rr' },
    { from: 's', to: 's' },
    { from: 't', to: 't' },
    { from: 'x', to: 'j' },
    { from: 'ʝ', to: 'y' },
    { from: 'z', to: 's' },

    // vowels & semi-vowels
    { from: 'a', to: 'a' },
    { from: 'e', to: 'e' },
    { from: 'i', to: 'i' },
    { from: 'o', to: 'o' },
    { from: 'u', to: 'u' },
    { from: 'w', to: 'u' },
    { from: 'j', to: 'hi', previous: ['#word'] }, { from: 'j', to: 'i' },
  ]
}
